import { render, staticRenderFns } from "./SumOfActions.vue?vue&type=template&id=30c5d9b0&scoped=true&"
import script from "./SumOfActions.vue?vue&type=script&lang=js&"
export * from "./SumOfActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c5d9b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib'
installComponents(component, {VLayout})
